import { service } from '@/helpers/http'
import store from '@/store'

/**
 * Retorna o módulo correto de notificações baseado no tipo de usuário.
 * Usa múltiplos sinais para evitar race condition quando user.mode
 * ainda não foi populado pelo login.
 */
const getNotificationModule = () => {
    const user = store.state.auth?.user
    if (user?.mode === 'teacher') return 'notificationTeacher'

    // Fallback: detectar contexto teacher pela rota ou localStorage
    const route = window._Vue?.$router?.currentRoute
    const isTeacherRoute = route?.name === 'teacher/page' || route?.name === 'teacher-panel'
    if (isTeacherRoute) return 'notificationTeacher'

    try {
        const stored = JSON.parse(localStorage.getItem('user') || '{}')
        if (stored?.mode === 'teacher') return 'notificationTeacher'
    } catch {}

    return 'notification'
}

export const ActionFetchNotifications = async ({ commit }) => {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
        const response = await service({
            module: getNotificationModule(),
            action: 'getNotifications',
            payload: { per_page: 20 }
        })

        commit('SET_NOTIFICATIONS', response.data || [])
        return response.data
    } catch (error) {
        commit('SET_NOTIFICATIONS', [])
        return []
    } finally {
        commit('SET_LOADING', false)
    }
}

export const ActionMarkAsRead = async ({ commit }, notificationId) => {
    try {
        await service({
            module: getNotificationModule(),
            action: 'markAsRead',
            params: { id: notificationId }
        })

        commit('MARK_AS_READ', notificationId)
    } catch (error) {
        throw error
    }
}

export const ActionMarkAllAsRead = async ({ commit }) => {
    try {
        await service({
            module: getNotificationModule(),
            action: 'markAllAsRead'
        })

        commit('MARK_ALL_AS_READ')
    } catch (error) {
        throw error
    }
}

export const ActionAddNotification = ({ commit }, notification) => {
    commit('ADD_NOTIFICATION', notification)
}
